import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useBloqueoAutogestion } from "services/bloqueoAutogestion";

export default function BloqueoAutogestion({ token, children }) {
  const { estado, loading, error, refetch } = useBloqueoAutogestion({ token });
  if (!token) return children;
  if (!estado && (loading || error)) return <Box minHeight="100vh" display="grid" sx={{ placeItems: "center", p: 3 }}>
    {error ? <Alert severity="error" action={<Button onClick={() => refetch().catch(() => {})}>Reintentar</Button>}>No se pudo verificar la disponibilidad del comedor.</Alert> : <CircularProgress />}
  </Box>;
  if (!estado?.bloqueaAppCompleta) return children;
  return <Box minHeight="100vh" display="grid" sx={{ placeItems: "center", p: 3, backgroundColor: "#f8f9fa" }}>
    <Box maxWidth={600} textAlign="center" role="status">
      <Typography variant="h4" mb={2}>Autogestión temporalmente suspendida</Typography>
      <Alert severity="info">{estado.mensaje || "La autogestión no está disponible durante este evento."}</Alert>
      <Typography variant="body2" mt={2}>Esta pantalla se actualizará cuando vuelva a estar disponible.</Typography>
      <Button sx={{ mt: 2 }} onClick={() => refetch().catch(() => {})}>Actualizar</Button>
    </Box>
  </Box>;
}

BloqueoAutogestion.propTypes = { token: PropTypes.string, children: PropTypes.node.isRequired };
